import { render, staticRenderFns } from "./TimerDashboard.vue?vue&type=template&id=d88519c0&scoped=true&"
import script from "./TimerDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TimerDashboard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TimerDashboard.vue?vue&type=style&index=0&id=d88519c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88519c0",
  null
  
)

export default component.exports